const i18nLoader = require('@px/i18n-loader').default;

module.exports = i18nLoader({
  /*'ar': require('./ar.json'),*/
  'da': require('./da.json'),
  'de': require('./de.json'),
  'el': require('./el.json'),
  'en': require('./en.json'),
  'es': require('./es.json'),
  'es-ES': require('./es-ES.json'),
  'fi': require('./fi.json'),
  'fr': require('./fr.json'),
  /*'fr-CA': require('./fr-CA.json'),*/
  /*'hi': require('./hi.json'),*/
  'id': require('./id.json'),
  'it': require('./it.json'),
  'ja': require('./ja.json'),
  'ko': require('./ko.json'),
  'mr': require('./mr.json'),
  'nb': require('./nb.json'),
  'nl': require('./nl.json'),
  'pl': require('./pl.json'),
  'pt-BR': require('./pt-BR.json'),
  'pt-PT': require('./pt-PT.json'),
  'qa-PS': require('./qa-PS.json'),
  'ru': require('./ru.json'),
  'sv': require('./sv.json'),
  'ta': require('./ta.json'),
  'th': require('./th.json'),
  'tr': require('./tr.json'),
  'uk': require('./uk.json'),
  'vi': require('./vi.json'),
  'zh-CN': require('./zh-CN.json'),
  'zh-HK': require('./zh-HK.json'),
  'zh-SG': require('./zh-SG.json'),
  'zh-TW': require('./zh-TW.json')
  })